import { trigger, transition, style, animate } from '@angular/animations';

/**
 * Mouvement mesuré (NA-04) : une entrée se décélère (ease-out) et dure 200 ms,
 * une sortie part vite (150 ms). Les 400 ms en ease-in d'avant faisaient
 * attendre chaque écran. Qui a demandé moins de mouvement n'en a aucun
 * (`provideNoopAnimations`, voir app.config.ts).
 */
export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate('150ms ease-in', style({ opacity: 0 })),
  ]),
]);

/**
 * Une page de détail entre par la droite, comme une pile qui s'empile.
 *
 * Elle vit sur la page elle-même : les onglets, eux, changent sur place,
 * sans glissement (NA-04).
 *
 * Pas de transition de sortie : le routeur détruit l'écran précédent
 * immédiatement, et l'attendre ferait clignoter un fond vide. L'entrée seule
 * dit « on avance d'un cran », le retour reste instantané.
 */
export const pageFromRight = trigger('pageFromRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate(
      '280ms cubic-bezier(0.22, 1, 0.36, 1)',
      style({ transform: 'translateX(0)' }),
    ),
  ]),
]);

export const swipeCard = trigger('swipeCard', [
  // Entrée en fondu, au même tempo que fadeIn
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms ease-out', style({ opacity: 1 })),
  ]),
  // Animation for leaving the view (slide out to the right)
  transition(':leave, * => out', [
    style({ transform: 'translateX(0)' }),
    animate('300ms ease', style({ transform: 'translateX(100%)' }))
  ])
]);
